export interface Memo {
  id: string;
  novelId?: string;
  title?: string;
  items: string[];
  s3BucketPath?: string;
  createdAt: string;
  updatedAt: string;
  /** メモのバージョン一覧（履歴）。manuscript の Version 型を共通利用 */
  versions?: import("./manuscript").Version[];
}

/** メモのバージョン履歴。manuscript の Version 型を共通利用（isLatest, versionId, lastModified） */
export type { Version as MemoVersion } from "./manuscript";

export interface MemoTag {
  id: string;
  name: string;
  createdAt: string;
  updatedAt: string;
}
